import React, { useEffect, useState } from 'react';
import api from '../../lib/api';
import { Button } from '../ui/button';
import { Mail, Phone, Trash2, RefreshCw, Inbox, Check } from 'lucide-react';

const TYPES = [
  { key: '', label: 'All' },
  { key: 'appointment', label: 'Appointments' },
  { key: 'contact', label: 'Contact' },
  { key: 'career', label: 'Careers' }
];

const badgeColor = { appointment: 'bg-brand-green/15 text-brand-greendark', contact: 'bg-brand-blue/15 text-brand-blue', career: 'bg-amber-100 text-amber-700' };

const Submissions = () => {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState('');
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get('/submissions', { params: filter ? { type: filter } : {} });
      setItems(r.data);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  const remove = async (id) => {
    await api.delete(`/submissions/${id}`);
    setItems((it) => it.filter((x) => x.id !== id));
  };
  const markRead = async (id) => {
    await api.patch(`/submissions/${id}/read`);
    setItems((it) => it.map((x) => (x.id === id ? { ...x, read: true } : x)));
  };

  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex gap-2 flex-wrap">
          {TYPES.map((t) => (
            <button key={t.key} onClick={() => setFilter(t.key)}
              className={`px-4 py-2 rounded-lg text-sm font-semibold transition-colors ${filter === t.key ? 'bg-brand-blue text-white' : 'bg-white text-slate-600 border border-slate-200 hover:bg-slate-50'}`}>
              {t.label}
            </button>
          ))}
        </div>
        <Button variant="outline" size="sm" onClick={load} className="gap-1"><RefreshCw size={15} /> Refresh</Button>
      </div>

      {loading ? (
        <div className="text-center py-16 text-slate-400">Loading…</div>
      ) : items.length === 0 ? (
        <div className="text-center py-16 text-slate-400 flex flex-col items-center gap-3">
          <Inbox size={40} /> No submissions yet.
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((s) => (
            <div key={s.id} className={`bg-white rounded-xl border p-5 shadow-sm ${s.read ? 'border-slate-200' : 'border-brand-green/40'}`}>
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="flex items-center gap-2">
                    <span className="font-display font-bold text-brand-bluedark">{s.name}</span>
                    <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${badgeColor[s.type] || 'bg-slate-100 text-slate-600'}`}>{s.type}</span>
                    {!s.read && <span className="text-xs font-semibold text-brand-green">• new</span>}
                  </div>
                  <div className="flex flex-wrap gap-4 text-sm text-slate-500 mt-1.5">
                    {s.phone && <span className="flex items-center gap-1"><Phone size={14} /> {s.phone}</span>}
                    {s.email && <span className="flex items-center gap-1"><Mail size={14} /> {s.email}</span>}
                    {s.service && <span>Service: <b className="text-slate-700">{s.service}</b></span>}
                    {s.position && <span>Position: <b className="text-slate-700">{s.position}</b></span>}
                  </div>
                  {s.message && <p className="text-slate-600 mt-2 text-sm leading-relaxed">{s.message}</p>}
                  <div className="text-xs text-slate-400 mt-2">{new Date(s.created_at).toLocaleString()}</div>
                </div>
                <div className="flex flex-col gap-1 shrink-0">
                  {!s.read && (
                    <Button variant="ghost" size="sm" onClick={() => markRead(s.id)} className="text-brand-green gap-1"><Check size={15} /> Read</Button>
                  )}
                  <Button variant="ghost" size="sm" onClick={() => remove(s.id)} className="text-red-500 hover:text-red-600 hover:bg-red-50 gap-1"><Trash2 size={15} /> Delete</Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Submissions;
